export const enUpdateNotification = {
    translation: {
        "Hay una nueva versión disponible": "There is a new version available",
        "Actualizar ahora": "Update now",
    }   
}